import { createAction, createErrorAction } from '../../actions/actionCreator';
import {
  GetChargebacksOptions,
  GetChargebacksResponse,
  UpdateChargebackOptions
} from '@card/commonlib';
import { ActionsType } from '@card/types';

export enum ChargebacksActionType {
  FetchStarted = 'chargebacks/fetch',
  FetchSuccess = 'chargebacks/fetch_success',
  FetchError = 'chargebacks/fetch_error',
  UpdateDataStarted = 'chargebacks/update_data_started',
  UpdateDataSuccess = 'chargebacks/update_data_success',
  UpdateDataError = 'chargebacks/update_data_error',
  GenerateReportStarted = 'chargebacks/generate_report_started',
  GenerateReportSuccess = 'chargebacks/generate_report_success',
  GenerateReportError = 'chargebacks/generate_report_error'
}

export const ChargebacksActions = {
  fetchStarted: (params: GetChargebacksOptions) =>
    createAction(ChargebacksActionType.FetchStarted, {
      pagination: {
        page: params.pagination.page || 1
        /* TODO: No funciona el endpoint enviando per_page. Consulté con Backend pero no tuve respuestas aún */
        /*per_page: Constants.SMALL_LIST_PAGE_SIZE*/
      },
      filters: params.filters
    }),
  fetchSuccess: (data: GetChargebacksResponse) =>
    createAction(ChargebacksActionType.FetchSuccess, data),
  fetchError: (error: Error) => createErrorAction(ChargebacksActionType.FetchError, error),
  updateDataStarted: (params: UpdateChargebackOptions) =>
    createAction(ChargebacksActionType.UpdateDataStarted, params),
  updateDataSuccess: () => createAction(ChargebacksActionType.UpdateDataStarted),
  updateDataError: (error: Error) =>
    createErrorAction(ChargebacksActionType.UpdateDataError, error),
  generateReportStarted: (params: GetChargebacksOptions) =>
    createAction(ChargebacksActionType.GenerateReportStarted, {
      pagination: {
        page: params.pagination.page || 1
        /* TODO: No funciona el endpoint enviando per_page. Consulté con Backend pero no tuve respuestas aún */
        /*per_page: Constants.SMALL_LIST_PAGE_SIZE*/
      },
      filters: params.filters
    }),
  generateReportSuccess: () => createAction(ChargebacksActionType.GenerateReportSuccess),
  generateReportError: (error: Error) => createErrorAction(ChargebacksActionType.FetchError, error)
};

export type ChargebacksAction = ActionsType<typeof ChargebacksActions>;
